import React, { useEffect, useState } from 'react';

import StatCards from '../../base/megatable/stat-cards';

import { api } from '../../../services/api';
import { Loader } from '../../misc/loader-utils';

import './merchant-strategy-totals.scss';

function MerchantStrategyTotals({
  merchId,
  statType,
  dateRange,
  strategyId,
  hidePercentDifference,
  hideTargetPacing,
}) {
  const [totals, setTotals] = useState({});
  const [loading, setLoading] = useState(true);
  const totalsEnd = `/api/v0/merchants/${merchId}/strategy/overview/tiles/`;
  const performanceEnd = `/api/v0/merchants/${merchId}/strategies/${strategyId}/performance/`;

  useEffect(() => {
    fetchTotals();
  }, [merchId, dateRange]);

  async function fetchTotals() {
    setLoading(true);

    const endpoint = strategyId ? performanceEnd : totalsEnd;
    const params = {
      date_from: dateRange.startDate.format('YYYY-MM-DD'),
      date_to: dateRange.endDate.format('YYYY-MM-DD'),
    };
    const resp = await api.get(endpoint, params);
    const totals = strategyId ? { goals: resp.data.data[0].stats } : resp.data.data[0].stats[0];

    setTotals(totals);
    setLoading(false);
  }

  const tiles = !loading ? (
    <StatCards
      data={totals}
      statType={statType}
      strategyId={strategyId}
      hidePercentDifference={hidePercentDifference}
      hideTargetPacing={hideTargetPacing}
    />
  ) : null;

  return (
    <div className="merchant-strategy-totals-container">
      <Loader loading={loading} />
      {tiles}
    </div>
  );
}

export default MerchantStrategyTotals;
